import React, { createRef, RefObject, useCallback, useEffect } from 'react';
import type { QualifioComponent as QualifioComponentProps } from '@src/interfaces';
import { loadScript } from '@src/utils/scripts';
import useHasBeenActive from '@src/utils/hooks/useHasBeenActive';
import { useRouter } from 'next/router';
import { trackEvent, trackPage } from '@src/utils/et';

type Qual = {
  push: (arg0: string[]) => void;
};
const Qualifio = ({title, url, options, showTitle = true}: QualifioComponentProps) => {
  const el: RefObject<HTMLDivElement> = createRef();

  const { asPath} = useRouter();
  const userHasBeenActive = useHasBeenActive();

  const hash = asPath.split('#')[1];
  useEffect(() => {
    if (!options || (!userHasBeenActive && !hash)) {
      return;
    }
    // eslint-disable-next-line camelcase
    loadScript<Qual>('https://prosiebensat1pulse1.qualifioapp.com/kit/qualp.2.min.js', '_qual_async').then(_qual_async => {
      // eslint-disable-next-line camelcase
      _qual_async.push(options);
    });
  }, [hash, options, userHasBeenActive]);

  // Handle messages coming from child page.
  const handleMessage = useCallback((event: MessageEvent) => {
    const { data } = event;
    const qualifioFrameWrapper = el.current
    const qualifioFrame = qualifioFrameWrapper?.querySelector('iframe') as HTMLIFrameElement

    const iframeOrigin = new URL(url).origin;
    const {iframeSrc} = data

    // Ensure the message comes from a trusted source
    if (event.origin !== iframeOrigin || iframeSrc && iframeOrigin !== url) {
      return;
    }
    if (!qualifioFrame) {
      console.error('HandleMessage error: iframe not found')
      return;
    }
    console.log('Message received:', event.data);

    if (data && data.cmd) {
      switch (data.cmd) {
        case 'resize':
          console.log('Resize requested. New height:', data.height);
          qualifioFrame.style.height = `${data.height }px`;
          break;
        case 'scrollToTop':
          console.log('Scroll to top of iframe requested.');
          qualifioFrame.scrollIntoView({ behavior: 'smooth' });
          break;
        case 'trackPage':
          console.log('Tracking page:', data.context);
          trackPage(data.context);
          break;
        case 'trackEvent':
          console.log('Tracking event:', data.eventName, data.payload);
          trackEvent(data.eventName, data.payload)
          break;
        default:
          console.log(`Message of type ${data.cmd} is not handled`)
          break;
      }
    }
  }, [el, url])

  useEffect(() => {
    window.addEventListener('message', handleMessage);

    return () => window.removeEventListener('message', handleMessage)
  }, [handleMessage, options]);

  if (!options) {
    // Fallback if HTML was not parsed.
    return (
      <section ref={el} className="paragraph qualifio-paragraph" id="umfrage">
        {showTitle &&title && <h1 className="component-title">{title}</h1>}
        {(userHasBeenActive || !userHasBeenActive && hash) &&
          <iframe height="600" src={url} title={title as string} width="100%" />
        }
      </section>
    );
  }

  const wrapperId = options[1];

  return (
    <section ref={el} className='paragraph qualifio-paragraph' id="umfrage">
      {showTitle && title && <h1 className="component-title">{title}</h1>}
      <div className='qualifio_iframe_wrapper' id={wrapperId} />
    </section>
  );
};

export default Qualifio;
